import { useTranslation } from "react-i18next";
import { Language } from "../types";
import { EXTERNAL_ROUTE } from "../constant/common.constant";

const useExternalRoute = () => {
  const { i18n } = useTranslation();

  const TRANSLATED_EXTERNAL_ROUTE = EXTERNAL_ROUTE[i18n.language as Language];

  return { TRANSLATED_EXTERNAL_ROUTE };
};

export default useExternalRoute;
